if (!customElements.get("multi-add-cart-button")) {
  class MultiAddCartButton extends HTMLElement {
    _headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };

    get _rootUrl() {
      let root = this.getAttribute('data-market-prefix') || '';

      if (!root || root === '/') {
        const path = window.location.pathname || '/';

        if (path === '/en-ca' || path.startsWith('/en-ca/')) {
          root = '/en-ca/';
        } else if (path === '/ca' || path.startsWith('/ca/')) {
          root = '/ca/';
        } else if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
          root = window.Shopify.routes.root;
        } else {
          root = '/';
        }
      }

      if (!root) root = '/';
      if (root !== '/' && !root.startsWith('/')) root = '/' + root;
      if (!root.endsWith('/')) root += '/';

      return root;
    }

    get _products() {
      const productsData = this.getAttribute('data-products');
      if (!productsData) return [];

      try {
        return JSON.parse(productsData);
      } catch (e) {
        console.error('产品数据格式错误:', e);
        return [];
      }
    }

    constructor() {
      super();
      this._boundAddToCart = this.addMultipleToCart.bind(this);
    }

    get _type() {
      return this.getAttribute('data-type') || '';
    }

    connectedCallback() {
      this.removeEventListener('click', this._boundAddToCart);
      this.addEventListener('click', this._boundAddToCart);
    }

    async addMultipleToCart(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      const button = this.querySelector('button');
      if (button && button.disabled) return;

      const products = this._products;

      if (!products.length) {
        alert("Please select the product first");
        console.warn('没有要添加的产品');
        return;
      }

      const items = products
        .map(product => ({
          id: parseInt(product.variantId, 10),
          quantity: Math.max(1, parseInt(product.quantity || 1, 10))
        }))
        .filter(item => !isNaN(item.id));

      if (!items.length) {
        console.error('没有有效的产品变体ID');
        return;
      }

      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }

      try {
        const response = await fetch(`${this._rootUrl}cart/add.js`, {
          method: 'POST',
          headers: this._headers,
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || `加购失败 (${response.status})`);
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
          window.ajaxCart.load();
        }

        const drawerBtn = document.querySelector('.js-drawer-open-button-right');
        if (this._type === 'checkout') {
          window.location.href = `${this._rootUrl}checkout`;
        } else if (drawerBtn) {
          drawerBtn.click();
        } else {
          window.location.href = `${this._rootUrl}cart`;
        }
      } catch (error) {
        console.error('加购错误:', error);
        alert(`error: ${error.message}`);
      } finally {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    }
  }

  customElements.define('multi-add-cart-button', MultiAddCartButton);
}